import { combineReducers } from "redux";
import preChatReducer from "./preChatReducer";
import uiReducer from "./uiReducer";
import { commonReducer } from "./commonReducer";
import { engagementReducer } from "./engagementReducer";
import chatReducer from "./chatReducer";

const reducers = combineReducers({
    chat: chatReducer,
    user: preChatReducer,
    ui: uiReducer,
    common: commonReducer,
    engagement: engagementReducer,
})

export default reducers;
